import React from "react";
import PropTypes from "prop-types";

import CheckBoxImage from "./img/Radiobutton.svg";
import CheckBoxImageChecked from "./img/Radiobutton-checked.svg";

export default function CheckBox(props) {
  return (
    <div style={{ display: "flex", margin: "4px 0", alignItems: "center" }}>
      <div
        style={{
          position: "relative",
          display: "inline-block",
          width: "18px",
          height: "18px",
          marginRight: "4px",
        }}
      >
        <img
          style={{
            pointerEvents: "none",
            position: "absolute",
            left: 0,
            top: 0,
            cursor: "pointer",
          }}
          src={props.checked ? CheckBoxImageChecked : CheckBoxImage}
        />
        <input
          id={props.value}
          type="checkbox"
          className="checkBox"
          name={props.value}
          value={props.value}
          checked={props.checked}
          onChange={props.onChange}
          style={{
            opacity: 0,
            width: "100%",
            height: "100%",
            margin: 0,
            cursor: "pointer",
          }}
        />
      </div>
      <label
        style={{ display: "inline-block", cursor: "pointer", padding: "9px 0" }}
        for={props.value}
      >
        {props.title}
      </label>
      {props.legend ? (
        <img
          src={props.legend}
          alt="Total DNA line indicator"
          style={{ marginLeft: "auto" }}
        />
      ) : null}
    </div>
  );
}
CheckBox.PropTypes = {
  value: PropTypes.string,
  onChange: PropTypes.function,
  checked: PropTypes.boolean,
  title: PropTypes.string,
  legend: PropTypes.object,
};
